import { Component, type ErrorInfo } from 'react';

import type { ErrorBoundaryProps, ErrorBoundaryState } from './types';

export class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
	constructor(props: ErrorBoundaryProps) {
		super(props);
		this.state = { hasError: false };
	}

	/** Cрабатывает первым при ошибке и меняет state */
	static getDerivedStateFromError(): ErrorBoundaryState {
		return { hasError: true };
	}

	/** Логируем или отправляем ошибку на сервер */
	componentDidCatch(error: Error, info: ErrorInfo) {
		// eslint-disable-next-line no-console
		console.error('Caught by ErrorBoundary:', error, info);
	}

	render() {
		const { hasError } = this.state;
		const { children } = this.props;

		if (hasError) {
			return <h3 style={{ padding: 15 }}>Something went wrong.</h3>;
		}

		return children;
	}
}
